// extracted by mini-css-extract-plugin
module.exports = {"media-container":"_2BaKl","mediaContainer":"_2BaKl"};